
<!-- 精品项目新增页面 -->
<template>
  <div>
    <span id="spanData">
      <el-card class="box-card">
        <!-- 设置title -->
        <h1 id="h1">项目发布</h1>

        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title"></el-input>
          </el-form-item>

          <!-- 上传文件控件 -->
          <el-form-item>
            <div id="divUpload">
              <el-upload
                class="upload-demo"
                drag
                :action="baseUrl+'/project/uploadProject'"
                multiple
                :data="uploadData"
                :on-success="handleFileUpload"
                :on-remove="handleFileRemove"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将项目文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </div>
          </el-form-item>

          <!-- 上传封面图片 -->
          <el-form-item>
            <div id="divUpload">
              <el-upload
                class="upload-demo"
                drag
                :action="baseUrl+'/project/uploadProjectImage'"
                multiple
                :data="uploadData"
                :on-success="handleUploadCoverImage"
                :on-remove="handleImageRemove"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将封面图片拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </div>
          </el-form-item>

          <!-- 所属分类 -->
          <el-form-item label="所属分类">
            <el-select v-model="form.projectType" placeholder="请选择">
              <el-option label="前端项目" value="1"></el-option>
              <el-option label="后端项目" value="2"></el-option>
            </el-select>
          </el-form-item>

          <!--费用类型 -->
          <el-form-item label="费用类型">
            <el-radio-group v-model="form.priceType" @input="changeRadio">
              <el-radio label="public">免费</el-radio>
              <el-radio label="pointsRequired">付费</el-radio>
            </el-radio-group>
            <!-- 积分输入框 -->
            <span id="spanNumber">
              <el-input-number
                v-model="price"
                :disabled="inputNumberStatu"
                :precision="2"
                :step="0.1"
                :max="100000"
                size="mini"
                controls-position="right"
              ></el-input-number>
            </span>
          </el-form-item>

          <!-- 使用wangEditor富文本 -->
          <el-form-item label="内容">
            <div id="editor"></div>
          </el-form-item>

          <el-form-item id="fabuButton">
            <el-button type="primary" @click="onSubmit">立即发布</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </span>
  </div>
</template>
   
  
  <script>
// 导入wangEditor
import E from "wangeditor";
import hljs from "highlight.js"; //代码高亮
// 导入封装请求方法
import {
  removeProject,
  removeProjectImage,
  addProject
} from "@/api/appProject/delicacyProject.js";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      // form表单中要上传的参数
      form: {},
      // 上传时，携带的额外参数,用户名
      uploadData: {
        userName: "",
      },

      // wangEditor用到的数据
      editor: null,

      // 设置校验规则
      rules: {
        title: [
          { required: true, message: "请输入项目标题", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      // 积分输入框是否禁用
      inputNumberStatu: true,
      // 积分值
      price: 0
    };
  },

  created() {
    this.handleAdd();
    this.getUserName();
  },

  // 计算函数
  computed: {
    baseUrl() {
      // 获取main.js中定义的公共参数地址
      return this.$baseUrl;
    },
  },

  methods: {
    ...mapMutations(["changeActiveIndex"]),
    // 获取当前登录用户
    getUserName() {
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      this.uploadData.userName = userData.data.userName;
    },

    // 文件上传成功后调用,返回的值，文件数据，文件列表数据
    handleFileUpload(response, file, fileList) {
      console.log("项目文件上传获取的响应数据：" + JSON.stringify(response));
      // 设置文件上传地址
      this.form.fileUrl = "https://"+response.data;
    },

    // 封面图片上传成功后调用,返回的值，文件数据，文件列表数据
    handleUploadCoverImage(response, file, fileList){
      console.log("封面图片上传获取的响应数据：" + JSON.stringify(response));
      // 设置封面图片上传地址
      this.form.coverUrl = "https://"+response.data;
    },

    //  项目-文件列表移除文件时的钩子
    async handleFileRemove(file, fileList) {
      console.log("文件被移除：" + JSON.stringify(file));
      const res = await removeProject(
        file.response.data,
        this.uploadData.userName
      );
      console.log("删除成功：" + JSON.stringify(res));
    },

    //  项目-封面图片-文件列表移除文件时的钩子
    async handleImageRemove(file, fileList) {
      console.log("文件被移除：" + JSON.stringify(file));
      const res = await removeProjectImage(
        file.response.data,
        this.uploadData.userName
      );
      console.log("删除成功：" + JSON.stringify(res));
    },

    // 可见范围单选按钮绑定值改变时执行
    changeRadio() {
      if (this.form.priceType === "pointsRequired") {
        this.inputNumberStatu = false;
      } else {
        this.inputNumberStatu = true;
      }
    },

    // 已进入新增页面调用
    handleAdd() {
      this.form = {}; // 新增数据的时候清空数据

      //   配置富文本编辑器
      this.setRichText();
    },

    // 封装富文本方法
    setRichText() {
      // this.$nextTick 确保在数据更新并导致的 DOM 变更完成之后执行某些操作。
      this.$nextTick(() => {
        this.editor = new E(`#editor`);
        // 设置代码高亮
        this.editor.highlight = hljs;
        // 配置图片上传
        // this.editor.config.uploadImgServer ="http://ailibrary.fun:8081/project/uploadEditerProjectImage"; //后台接口
        this.editor.config.uploadImgServer =this.$baseUrl+"/project/uploadEditerProjectImage"; //后台接口
        this.editor.config.uploadFileName = "file"; //接收的名称
        // 配置上传视频
        this.editor.config.uploadVideoServer =this.$baseUrl+"/project/uploadEditerProjectVideo";
        this.editor.config.uploadVideoName = "file";
        // 配置图片上传额外上传参数
        this.editor.config.uploadImgParams = {
          type: "img",
          userName: this.uploadData.userName,
        };
        // 配置视频上传额外参数
        this.editor.config.uploadVideoParams = {
          type: "video",
          userName: this.uploadData.userName,
        };
        // 配置视频上传的大小
        this.editor.config.uploadVideoMaxSize = 5 * 1024 * 1024 * 1024;
        // 设置图片上传大小
        this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 设置最大上传文件为 10MB
        this.editor.config.uploadImgMaxLength = 5; // 可同时上传的最大图片数量
        // 设置参数
        this.editor.create(); // 创建
      });
    },

    // 提交按钮
    async onSubmit() {
      // 获取富文本中的内容
      let editor = this.editor.txt.html();
      this.form.content = editor; //设置内容
      this.form.price = this.price; //设置费用
      // 获取当前用户id
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      this.form.userId = userData.data.userId;
      // 获取form表单中的内容
      console.log("获取发布的内容" + JSON.stringify(this.form));
      const res = await addProject(this.form);
      if (res.status === "200") {
        // 发布成功
        // 进行提示
        this.$message({
          message: res.message,
          type: "success",
        });

        // 页面跳转到面试题库,并修改仓库中导航的选中
        this.changeActiveIndex("2");
        this.$router.push("/delicacyProject");
      }
    }
  },
};
</script>

  <style scoped>
/* 积分输入框样式 */
#spanNumber {
  margin-left: 10px;
}

/* 外围card样式 */
.box-card {
  width: 70%;
}

/* 外围span标签样式 */
#spanData {
  display: flex;
  justify-content: center;
}

/* 发布文章标题 */
#h1 {
  text-align: center;
}

/* 题目标签样式 */
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
/* ----------------------- */

/* 发布按钮样式 */
#fabuButton {
  text-align: center;
}
</style>